import ar from './locales/ar-AR.json';
import en from './locales/en-US.json';

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'ar',
  fallbackLocale: 'ar',
  globalInjection: true,
  messages: {
    ar,
    en,
  },
}));
